module.exports = __webpack_public_path__ + "img/astronaut.84c32ff9.png";